/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WaterHeatingEnum = 1 | 2;

export const WaterHeatingEnum = {
    NUMBER_1: 1 as WaterHeatingEnum,
    NUMBER_2: 2 as WaterHeatingEnum
};

